module.exports = __webpack_public_path__ + "media/images/element/16-50184869e5f147780e4af294d473505e.svg";